import { UserPermission } from '@/modules/permission/enum';
export const applianceRoutes = [
    {
        path: '',
        name: 'Appliance',
        exact: true,
        component: () => import('../views/ApplianceIndex.vue'),
        meta: {
            breadcrumb: [{ parent: 'Appliance', label: 'Manage Appliances' }],
            permissions: [UserPermission.READ_CALLSIGN],
        },
    },
];
